import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchReceiptProductsGrid} from 'api';
import {createListModel} from 'core/hooks/list';
import {rootDomain} from 'core/rootDomain';
import {ProductContentRawRow} from 'types';

const domain = rootDomain.createDomain('DocumentsProductListDomain');

export const Gate = createGate<{receiptId: string}>('DocumentsProductListGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchReceiptProductsGrid,
});
export const fetchTotalCountFx = domain.createEffect({
    name: 'fetchTotalCountFx',
    handler: fetchReceiptProductsGrid,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    sorting$,
    sortingChanged,
} = createListModel({
    domain,
});

export const data$ = domain.createStore<ProductContentRawRow[]>([]);
export const totalCount$ = domain.createStore<number>(0);

export const listState$ = combine({
    data: data$,
    totalCount: totalCount$,
    filters: filters$,
    sorting: sorting$,
    pageIncremented,
    isLoading: fetchDataFx.pending || fetchTotalCountFx.pending,
});
